<template>
  <FormControl v-bind="props()">
    <component
      :autofocus="autofocus"
      :class="{ 'is-invalid': hasError }"
      :disabled="disabled"
      :id="identifier"
      :is="element"
      :name="name"
      :readonly="readonly"
      :value="readonlyValue"
      class="form-control"
      @blur="validate"
      @focus="focus"
      @input="input">
      <template v-if="isSelect">
        <option
          v-if="placeholderText !== ''"
          value="">{{ placeholderText }}</option>
        <option
          v-for="(option, key) in options"
          :key="key"
          :value="option.value"
          :selected="option.value == value">
          {{ option.text }}
        </option>
      </template>
    </component>
    <template v-slot:prepend>
      <slot name="prepend"/>
    </template>
    <template v-slot:append>
      <slot name="append"/>
    </template>
  </FormControl>
</template>

<script>
import { FormInput } from '@/mixins'

import FormControl from './FormControl.vue'

export default {
  name: 'AppSelect',

  components: {
    FormControl
  },

  mixins: [FormInput],

  props: {
    items: { default: () => [], type: Array },
    model: Array,
    modelText: { default: 'name', type: String },
    modelTextFallback: { default: '', type: String },
    modelValue: { default: '_id', type: String },
    source: String,
    truthy: Boolean
  },

  computed: {
    element () {
      return this.readonly || this.disabled ? 'input' : 'select'
    },

    options () {
      if (this.source) {
        return require(`../data/${this.source}.js`).default
      }

      if (this.model) {
        const options = []

        this.model.forEach((model) => options.push({
          text: this.$_.get(model, this.modelText) || this.$_.get(model, this.modelTextFallback),
          value: this.$_.get(model, this.modelValue)
        }))

        return options
      }

      if (this.truthy) {
        return [{
          text: 'Yes',
          value: true
        }, {
          text: 'No',
          value: false
        }]
      }

      return this.items
    },

    readonlyValue () {
      if (this.isSelect()) return false

      let display = ''

      this.options.filter(({ text, value }) => {
        if (this.value === value) {
          display = text
        }
      })

      return display
    }
  },

  methods: {
    isSelect () {
      return this.element === 'select'
    },

    transform (value) {
      if (this.truthy) {
        return value === 'true'
      }

      return value
    }
  }
}
</script>
